import {
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionIcon,
  AccordionPanel,
  Box,
  Stack,
  StackDivider,
  Text,
  useColorModeValue,
} from "@chakra-ui/react";
import { TEXT_COLOR_LIGHT, TEXT_COLOR_DARK } from "./utils";

interface Props {
  leftPanel: JSX.Element;
  rightPanel: JSX.Element;
  bottomPanel: JSX.Element;
  noOfActiveFilters: number;
}

export function ManualFilters({ leftPanel, rightPanel, bottomPanel, noOfActiveFilters }: Props) {
  const textColor = useColorModeValue(TEXT_COLOR_LIGHT, TEXT_COLOR_DARK);

  return (
    <Accordion mt="3" allowToggle>
      <AccordionItem border="none">
        <AccordionButton w="auto" px="2" _hover={{ bg: "initial" }}>
          <Box
            as="span"
            flex="1"
            textAlign="left"
            fontSize="sm"
            color={textColor}
            fontWeight="semibold"
          >
            Or search manually{" "}
            {noOfActiveFilters > 0 ? (
              <Text
                as="span"
                bg={textColor}
                p="0.5"
                px="1.5"
                ml="2"
                fontSize="11px"
                borderRadius="md"
                color="white"
              >
                {noOfActiveFilters}
              </Text>
            ) : null}
          </Box>
          <AccordionIcon color={textColor} ml="2" />
        </AccordionButton>
        <AccordionPanel pl="2" pr="0" pt="5" pb="0">
          <Stack
            direction={{ base: "column", md: "row" }}
            divider={
              <StackDivider
                borderColor="gray.200"
                h="28"
                maxH="100%"
                my="auto"
              />
            }
            spacing="8"
          >
            <Box w="47%">{leftPanel}</Box>
            <Box w="53%">{rightPanel}</Box>
          </Stack>
          <Box>{bottomPanel}</Box>
        </AccordionPanel>
      </AccordionItem>
    </Accordion>
  );
}
